module.exports = __webpack_public_path__ + "static/media/Edit-Black.2c6eefe7.svg";